import { render, staticRenderFns } from "./Solidarity.view.vue?vue&type=template&id=1387f562&"
import script from "./Solidarity.view.vue?vue&type=script&lang=js&"
export * from "./Solidarity.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports